import { AppIndex } from "~lib/App";
import { AppName } from "~shared/messageTypes";
import { CoopPokerApp } from "./CoopPokerApp";

export const CoopPoker: AppIndex = {
  id: AppName.COOP_POKER,
  name: "Coop Poker",
  app: CoopPokerApp,
};
